'use client';

import { useSession } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import AuthForm from '../../../components/AuthForm';

export default function SignInPage() {
  const { data: session, status } = useSession();
  const router = useRouter();
  const searchParams = useSearchParams();
  
  const callbackUrl = searchParams.get('callbackUrl') || '/home';
  const verified = searchParams.get('verified') === 'true';

  useEffect(() => {
    if (status === 'authenticated' && session?.user) {
      // User is authenticated, redirect to callback URL or chat
      router.push(callbackUrl);
    }
  }, [status, session, router, callbackUrl]);

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (status === 'authenticated') {
    return null; // Will redirect to dashboard
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          
          <div className="flex items-center justify-center mb-6">
            <Image
              src="/brand/delfin-logo-full.svg"
              alt="Delfin"
              width={200}
              height={40}
              priority
              className="h-8 w-auto dark:hidden"
            />
            <Image
              src="/brand/delfin-logo-full-ivory.svg"
              alt="Delfin"
              width={200}
              height={40}
              priority
              className="h-8 w-auto hidden dark:block"
            />
          </div>
        </div>

        {/* Auth Form */}
        <AuthForm callbackUrl={callbackUrl} verified={verified} mode="signin" />

        {/* Additional Info */}
        <div className="text-center">
          <div className="space-y-3 text-sm text-muted-foreground">
            <p>
              By signing in, you agree to our{' '}
              <Link href="/terms" className="font-medium text-primary hover:text-primary">
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link href="/privacy" className="font-medium text-primary hover:text-primary">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
